export interface ITableColumn {
  key: string;
  label: string;
  isSortable?: boolean;
  cssClass?: string;
  cssStyle?: object;
  inlineStyle?: object;
  loadingInlineStyle?: object;
  innerCssClass?: string;
  isfromDeviceManager?: boolean;
  isRenderFunction?: boolean;
  renderFunction?: any;
  renderImage?: boolean;
  isTemplateRef?: boolean;
  templateRef?: any;
}
